import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authSlice from './slices/auth.slice';
import exampleSlice from './slices/example.slice';
import languageSlice from './slices/language.slice';
import loaderSlice from './slices/loader.slice';
import toastSlice from './slices/toast.slice';
import organizationSlice from './slices/organization.slice';
import clientsSlice from './slices/clients.slice';
import userProfileSlice from './slices/user-profile.slice';
import timeTrackingSlice from './slices/time-tracking.slice';
import notificationsSlice from './slices/notifications.slice';
import projectsSlice from './slices/projects.slice';
import projectsUiSlice from './slices/projectsUi.slice';
import { AppConfig } from '../config/AppConfig';
import navigationSlice from './slices/navigation/navigation.slice';
import signInSlice from './slices/sign-in.slice';
import mediaQuerySlice from './slices/media-query.slice';
import organizationPoliciesSlice from './slices/organization-policies.slice';
import userOrganizationPoliciesSlice from './slices/user-policies.slice';
import branchSlice from './slices/branch.slice';
import holidaySlice from './slices/holiday.slice';
import importHolidaysSlice from './slices/import-holidays.slice';
import addEditPolicySlice from './slices/add-edit-policy.slice';
import addTeamMembersSlice from './slices/add-team-members.slice';
import projectAssigneesSlice from './slices/project-assignees.slice';
import notificationCenterSlice from './slices/notification-center.slice';
import featureFlagsSlice from './slices/feature-flags.slice';
import featureConfigSlice from './slices/feature-config.slice';
import activeSubscriptionSlice from './slices/active-subscription.slice';

export * from './restoreAll';

export const store = configureStore({
    reducer: {
        example: exampleSlice,
        loader: loaderSlice,
        toast: toastSlice,
        auth: authSlice,
        language: languageSlice,
        clients: clientsSlice,
        organization: organizationSlice,
        userProfile: userProfileSlice,
        timeTracking: timeTrackingSlice,
        notifications: notificationsSlice,
        projects: projectsSlice,
        projectsUi: projectsUiSlice,
        navigation: navigationSlice,
        signIn: signInSlice,
        mediaQuery: mediaQuerySlice,
        organizationPolicies: organizationPoliciesSlice,
        userOrganizationPolicies: userOrganizationPoliciesSlice,
        branch: branchSlice,
        holidays: holidaySlice,
        importHolidays: importHolidaysSlice,
        addEditPolicy: addEditPolicySlice,
        addTeamMembers: addTeamMembersSlice,
        projectAssignees: projectAssigneesSlice,
        notificationCenter: notificationCenterSlice,
        featureFlags: featureFlagsSlice,
        featureConfig: featureConfigSlice,
        activeSubscription: activeSubscriptionSlice,
    },
    devTools: AppConfig.isDevelopment,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const dispatch = store.dispatch;
export const getState = store.getState;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
